import React, { createContext, ReactNode, useContext, useState } from "react";

interface IQuestionsContext {
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  selectedDocumentExcerpt: string[];
  setSelectedDocumentExcerpt: React.Dispatch<React.SetStateAction<string[]>>;
  documentExcerptOption: string;
  setDocumentExcerptOption: React.Dispatch<React.SetStateAction<string>>;
  selectedTextError: string;
  setSelectedTextError: React.Dispatch<React.SetStateAction<string>>;
  loadingQuery: boolean;
  setLoadingQuery: React.Dispatch<React.SetStateAction<boolean>>;
  queryReply: string;
  setQueryReply: React.Dispatch<React.SetStateAction<string>>;
}

const QuestionsContext = createContext<IQuestionsContext | null>(null);

export const QuestionsProvider = ({ children }: { children: ReactNode }) => {
  const [query, setQuery] = useState("");
  const [selectedDocumentExcerpt, setSelectedDocumentExcerpt] = useState<string[]>(["full-document"]);
  const [documentExcerptOption, setDocumentExcerptOption] = useState("Full Document");
  const [selectedTextError, setSelectedTextError] = useState("");
  const [loadingQuery, setLoadingQuery] = useState(false);
  const [queryReply, setQueryReply] = useState("");

  return (
    <QuestionsContext.Provider
      value={{
        query,
        setQuery,
        selectedDocumentExcerpt,
        setSelectedDocumentExcerpt,
        documentExcerptOption,
        setDocumentExcerptOption,
        selectedTextError,
        setSelectedTextError,
        loadingQuery,
        setLoadingQuery,
        queryReply,
        setQueryReply,
      }}
    >
      {children}
    </QuestionsContext.Provider>
  );
};

export const useQuestions = () => {
  const context = useContext(QuestionsContext);
  if (!context) {
    throw new Error("useQuestions must be used within a QuestionsProvider");
  }

  return context;
};
